import { useToast as useChakraToast, type UseToastOptions } from '@chakra-ui/react';

import toastMessages from '@/messages/toast';
import { TCustomAxiosError } from '@/services/api';

export const getDefaultToastProps = () => ({
  title: toastMessages.genericErrorHeading,
  description: toastMessages.genericErrorDescription,
  isClosable: true,
  variant: 'left-accent',
  timeout: 3000,
  id: 'e6ffafc3',
});

const useToast = () => {
  const chakraToast = useChakraToast();

  return (toastConfig?: UseToastOptions, error?: TCustomAxiosError) => {
    if (error) {
      // The API client already displays these across every screen.
      if (
        error.reason === 'ACCOUNT_OPERATION_IN_PROGRESS' ||
        error.reason === 'MAINTENANCE_FREEZE' ||
        error.code === 503
      )
        return;
      const errorObj = error?.errors?.[0];
      const title = errorObj?.name ?? toastMessages.genericErrorHeading;
      const description = errorObj?.message ?? toastMessages.genericErrorDescription;

      return chakraToast({
        ...getDefaultToastProps(),
        title,
        description,
        ...toastConfig,
        status: 'error',
        duration: 5000,
        position: 'bottom',
      });
    }

    return chakraToast({
      status: 'success',
      position: toastConfig?.status === 'error' ? 'bottom' : 'top-right',
      ...getDefaultToastProps(),
      ...toastConfig,
    });
  };
};

export default useToast;
